import reduxApi from 'redux-api';
import customFetch from 'api/axios';
import { API_URL } from 'constants/config';
import { isEmpty } from 'lodash';

// Example
export default reduxApi({
  postThamQuyen: {
    url: `${API_URL}/thamQuyenGiaiQuyets`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postLoaiTaiLieu: {
    url: `${API_URL}/loaiTaiLieus`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postCapDonViHanhChinh: {
    url: `${API_URL}/capDonViHanhChinhs`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postDonViHanhChinh: {
    url: `${API_URL}/donViHanhChinhs`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postChucVu: {
    url: `${API_URL}/chucVus`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postQuocTich: {
    url: `${API_URL}/quocTichs`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postVaiTro: {
    url: `${API_URL}/vaiTros`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postCoQuan: {
    url: `${API_URL}/coQuanQuanLys`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postCapCoQuan: {
    url: `${API_URL}/capCoQuanQuanLys`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postLinhVucDonThu: {
    url: `${API_URL}/linhVucDonThus`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postDanToc: {
    url: `${API_URL}/danTocs`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postCongChuc: {
    url: `${API_URL}/congChucs`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postThamSo: {
    url: `${API_URL}/thamSos`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postQuyTrinh: {
    url: `${API_URL}/maTran/donVi`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postLoaiCapCoQuan: {
    url: `${API_URL}/loaiCoQuanQuanLys`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postHuongDanSuDung: {
    url: `${API_URL}/huongDanSuDungs`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  updateHuongDanSuDung: {
    url: `${API_URL}/huongDanSuDungs/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  getHuongDanSuDung: {
    url: `${API_URL}/huongDanSuDungs`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThamQuyen: {
    url: `${API_URL}/thamQuyenGiaiQuyets`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLoaiTaiLieu: {
    url: `${API_URL}/loaiTaiLieus`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCapDonViHanhChinh: {
    url: `${API_URL}/capDonViHanhChinhs`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDonViHanhChinh: {
    url: `${API_URL}/donViHanhChinhs`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getInfoDonViHanhChinh: {
    url: `${API_URL}/donViHanhChinhs/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getChucVu: {
    url: `${API_URL}/chucVus`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getListChucVu: {
    url: `${API_URL}/chucVus?page=:0size=1000`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getQuocTich: {
    url: `${API_URL}/quocTichs`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCMND: {
    url: `${API_URL}/coQuanQuanLys/noiCapCMNDs`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getQuyen: {
    url: `${API_URL}/quyens?page=0&size=1000`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getListVaiTro: {
    url: `${API_URL}/vaiTros/combobox?page=0&size=1000`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getListVaiTrotheoDV: {
    url: `${API_URL}/vaiTros/comboboxTheoDonVi?page=0&size=1000`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getListLoaiVaiTro: {
    url: `${API_URL}/loaiVaiTros?page=0&size=1000`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getVaiTro: {
    url: `${API_URL}/vaiTros`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCoQuanTW: {
    url: `${API_URL}/coQuanQuanLys/capTrungUong`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCapCoQuanQuanLyTW: {
    url: `${API_URL}/capCoQuanQuanLys/capCoQuanTW`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCoQuan: {
    url: `${API_URL}/coQuanQuanLys`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLoaiCoQuanQL: {
    url: `${API_URL}/loaiCoQuanQuanLys`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getListCoQuan: {
    url: `${API_URL}/coQuanQuanLys/donVis?page=0&size=1000`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDonViTrucThuoc: {
    url: `${API_URL}/coQuanQuanLys/donViTrucThuocs?page=0&size=1000`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCapCoQuan: {
    url: `${API_URL}/capCoQuanQuanLys`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDanToc: {
    url: `${API_URL}/danTocs`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLinhVucDonThu: {
    url: `${API_URL}/linhVucDonThus`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCongChuc: {
    url: `${API_URL}/congChucs`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getToDanPho: {
    url: `${API_URL}/toDanPhos`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCapPhuongXa: {
    url: `${API_URL}/donViHanhChinhs/capPhuongXa?page=0page&size=1000&sort=ten,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getcapQuanHuyen: {
    url: `${API_URL}/donViHanhChinhs/capQuanHuyen?page=0&size=1000&sort=ten,desc&cha=:cha`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getcapTinhThanhPho: {
    url: `${API_URL}/donViHanhChinhs/capTinhThanhPho?page=0&size=1000&sort=ten,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getThamSo: {
    url: `${API_URL}/thamSos`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getListQuyTrinh: {
    url: `${API_URL}/maTran/list`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLoaiCapCoQuan: {
    url: `${API_URL}/loaiCoQuanQuanLys`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  deleteThamQuyen: {
    url: `${API_URL}/thamQuyenGiaiQuyets/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteLoaiTaiLieu: {
    url: `${API_URL}/loaiTaiLieus/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteCapDonViHanhChinh: {
    url: `${API_URL}/capDonViHanhChinhs/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteDonViHanhChinh: {
    url: `${API_URL}/donViHanhChinhs/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteChucVu: {
    url: `${API_URL}/chucVus/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteQuocTich: {
    url: `${API_URL}/quocTichs/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteVaiTro: {
    url: `${API_URL}/vaiTros/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteCoQuan: {
    url: `${API_URL}/coQuanQuanLys/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteDanToc: {
    url: `${API_URL}/danTocs/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteLinhVucDonThu: {
    url: `${API_URL}/linhVucDonThus/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE',
        params: _params
      };
    }
  },
  deleteCapCoQuan: {
    url: `${API_URL}/capCoQuanQuanLys/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteToDanPho: {
    url: `${API_URL}/toDanPhos/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteCongChuc: {
    url: `${API_URL}/congChucs/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteThamSo: {
    url: `${API_URL}/thamSos/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteQuyTrinh: {
    url: `${API_URL}//maTran/:idDonVi`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteLoaiCapCoQuan: {
    url: `${API_URL}/loaiCoQuanQuanLys/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  updateVaiTro: {
    url: `${API_URL}/vaiTros/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateThamQuyen: {
    url: `${API_URL}/thamQuyenGiaiQuyets/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateLoaiTaiLieu: {
    url: `${API_URL}/loaiTaiLieus/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateCapCoQuan: {
    url: `${API_URL}/capCoQuanQuanLys/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateCapDonViHanhChinh: {
    url: `${API_URL}/capDonViHanhChinhs/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateDonViHanhChinh: {
    url: `${API_URL}/donViHanhChinhs/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateChucVu: {
    url: `${API_URL}/chucVus/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateQuocTich: {
    url: `${API_URL}/quocTichs/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateDanToc: {
    url: `${API_URL}/danTocs/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateLinhVucDonThu: {
    url: `${API_URL}/linhVucDonThus/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateToDanPho: {
    url: `${API_URL}/toDanPhos/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateCoQuan: {
    url: `${API_URL}/coQuanQuanLys/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateCongChuc: {
    url: `${API_URL}/congChucs/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateThamSo: {
    url: `${API_URL}/thamSos/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateLoaiCapCoQuan: {
    url: `${API_URL}/loaiCoQuanQuanLys/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  postLinhVucDoiTuongThanhTra: {
    url: `${API_URL}/linhVucDoiTuongThanhTras`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  getLinhVucDoiTuongThanhTra: {
    url: `${API_URL}/linhVucDoiTuongThanhTras?page=0&size=1000`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  updateLinhVucDoiTuongThanhTra: {
    url: `${API_URL}/linhVucDoiTuongThanhTras/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      }
    }
  },
  deleteLinhVucDoiTuongThanhTra: {
    url: `${API_URL}/linhVucDoiTuongThanhTras/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  // Đối tượng thanh tra
  postDoiTuongThanhTra: {
    url: `${API_URL}/doiTuongThanhTras`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  getDoiTuongThanhTra: {
    url: `${API_URL}/doiTuongThanhTras`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  updateDoiTuongThanhTra: {
    url: `${API_URL}/doiTuongThanhTras/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      }
    }
  },
  deleteDoiTuongThanhTra: {
    url: `${API_URL}/doiTuongThanhTras/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  // End đối tượng thanh tra
  // Nhóm đối tượng thanh tra 
  getNhomDoiTuongThanhTra: {
    url: `${API_URL}/nhomDoiTuongThanhTras`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  postNhomDoiTuongThanhTra: {
    url: `${API_URL}/nhomDoiTuongThanhTras`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  updateNhomDoiTuongThanhTra: {
    url: `${API_URL}/nhomDoiTuongThanhTras/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      }
    }
  },
  deletenhomDoiTuongThanhTras: {
    url: `${API_URL}/nhomDoiTuongThanhTras/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  // End nhóm đối tượng thanh tra
  getLoaiDoiTuongThanhTra: {
    url: `${API_URL}/loaiDoiTuongThanhTras?page=0&size=1000`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLinhVucDonThuTimKiem: {
    url: `${API_URL}/linhVucDonThus/linhVucDonThuTimKiems?page=0&size=1000`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDonViHanhChinhTimKiem: {
    url: `${API_URL}/donViHanhChinhs/danhSachDonViTimKiems?page=0&size=1000`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCapDonViHanhChinhTimKiem: {
    url: `${API_URL}/capDonViHanhChinhs/capDonViHanhChinhTimKiems?page=0&size=1000`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCoQuanQuanLyTimKiem: {
    url: `${API_URL}/coQuanQuanLys/coQuanQuanLyTimKiems?page=0&size=1000`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCapCoQuanQuanLyTimKiem: {
    url: `${API_URL}/capCoQuanQuanLys/capCoQuanQuanLyTimKiems?page=0&size=1000`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDonViNgoai: {
    url: `${API_URL}/donViNgoaiHeThongs?page=0&size=1000`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  postDonViNgoai: {
    url: `${API_URL}/donViNgoaiHeThongs`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  updateDonViNgoai: {
    url: `${API_URL}/donViNgoaiHeThongs/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      }
    }
  },
  deleteDonViNgoai: {
    url: `${API_URL}/donViNgoaiHeThongs/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  getTrangThaiThayDoiNguoiDung: {
    url: `${API_URL}/nguoiDung/trangThaiThayDoiNguoiDung?page=0&size=1000`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLoaiBaoCao: {
    url: `${API_URL}/loaiBaoCaoTongHops?page=0&size=1000`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCauHinhBaoCao: {
    url: `${API_URL}/cauHinhBaoCaos`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  updateCauHinhBaoCao: {
    url: `${API_URL}/cauHinhBaoCaos/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      }
    }
  },
  postCauHinhBaoCao: {
    url: `${API_URL}/cauHinhBaoCaos`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  deleteCauHinhBaoCao: {
    url: `${API_URL}/cauHinhBaoCaos/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  getCapNhatNguoiDung: {
    url: `${API_URL}/timKiemDanhSachCanBoDangXuLys/canBo`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDanhSachXuLy: {
    url: `${API_URL}/dons/cong-chuc-tham-gia`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDanhSachDonTheoDonVi: {
    url: `${API_URL}/dons/danh-sach-by-don-vi`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  deleteDonTrongDonVi: {
    url: `${API_URL}/dons/delete-theo-don-vi`,
    options: (url, params, getState) => {
      return {
        method: 'DELETE',
        data: !isEmpty(params.donIds) ? [...params.donIds] : []
      };
    }
  },
  switchCongChuc: {
    url: `${API_URL}/dons/swtich-cong-chuc`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  getCongChucSoNoiVu: {
    url: `${API_URL}/congChucSoNoiVus/local`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDonViSoNoiVu: {
    url: `${API_URL}/donViSoNoiVus/local`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  updateCapNhatNguoiDung: {
    url: `${API_URL}/capNhatThayDoiCanBoDangXuLys`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      }
    }
  },
  getDanhMucVideo: {
    url: `${API_URL}/danhMucVideos`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  postDanhMucVideo: {
    url: `${API_URL}/danhMucVideos`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  updateDanhMucVideo: {
    url: `${API_URL}/danhMucVideos/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      }
    }
  },
  deleteDanhMucVideo: {
    url: `${API_URL}/danhMucVideos/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  getLoaiVideo: {
    url: `${API_URL}/loaiVideos`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getVideo: {
    url: `${API_URL}/videos`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  postVideo: {
    url: `${API_URL}/videos`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  updateVideo: {
    url: `${API_URL}/videos/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      }
    }
  },
  deleteVideo: {
    url: `${API_URL}/videos/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  doiTuongThanhTraChuaCoCuoc: {
    url: `${API_URL}/timDoiTuongThanhTrasChuaCoCuocThanhTra`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        params: params.pageData,
        data: params
      };
    }
  }
}).use('fetch', customFetch);



// WEBPACK FOOTER //
// ./src/api/danhMuc.js